import { VuexModule, Module, Mutation, Action } from "vuex-class-modules";
import store from "../index";
import { authService } from "@/services/auth.service";
import { Credentials } from "@/types/login";
import { IdTokenResult, User } from "firebase/auth";

@Module
class AuthModule extends VuexModule 
{
  private _user: {[key: string]: any}|null = null

  get user() { return this._user; }

  get isLoggedIn() { return this.user?.uid != undefined }

  @Action
  onAuth(user: User) {
    user.getIdTokenResult().then((tokenResult: IdTokenResult) => {
      const { is_admin } = tokenResult.claims
      const { email, displayName, uid } = user
      this.setUser({ email, displayName, uid, is_admin } )
    })
  }

  @Action
  getLogin(formdata: Credentials) {
    authService.signIn(formdata.email, formdata.password)
    .then(user => {
      if (user != null) {
        this.onAuth(user);
      }
    })
  }
  @Action
  getLogout() {
    authService.signOut();
    this.setLogout();
  }

  @Mutation
  setUser(user: {[key: string]: any}|null) {
    this._user = user;
  }

  @Mutation
  setLogout() {
    this._user = null;
  }
}
const name = "authModule";

export const authModule = new AuthModule({
  store,
  name,
});
